<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>
    <SysHeader/>
    <sidebar class="sidebar-container"/> 
    <div class="main-container" id="main-container">
      <tags-view/>
      <app-main/>
    </div>
  </div>
</template>

<script>
import { Sidebar, AppMain, TagsView, SysHeader } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'Layout',
  components: { 
    Sidebar,
    AppMain,
    TagsView,
    SysHeader
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
     this.$store.dispatch('closeSideBar', { withoutAnimation: false })
    }
  },
  mounted() {
    let that = this;
    // 注：window.onresize只能在项目内触发1次
    window.onresize = function windowResize() {
      // 通过捕获系统的onresize事件触发我们需要执行的事件 
        let height = document.body.clientHeight - 80 - 34;  
        that.$store.dispatch('setMainContainerSize', {height: height, width: '100%'})
    };
    window.onresize();
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  .main-container{
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue